module.exports = __webpack_public_path__ + "img/logo.926eea9e.png";